import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";
import { MailsSection } from "../../components/pages/mails/MailsSection";

export function Mails() {

    return (
        <PageContainerAuth section="mailings-history" pageTitle="Historique des envois">
            <MailsSection />
        </PageContainerAuth>
    );
}